import { useMemo } from 'react'
import { trpc } from '@klear/ui/lib/trpc'
import { parentDefaultsFromOperational } from '@klear/operational/wire.client'
import { parentDefaultsFromPurchaseOrder } from '@klear/purchase-order/wire.client'
import { type EventFormParentDefaults } from '@klear/order-event-ui/event-shared/event-form-read-mappers'

export function useEventFormParentDefaults({ parentEventId, traderId }: { parentEventId?: number; traderId: number }): {
  parentId: number | null
  parentDefaults: EventFormParentDefaults | undefined
  isLoading: boolean
} {
  const parentId = parentEventId != null && parentEventId > 0 ? parentEventId : null

  const parentPoQuery = trpc.purchaseOrder.get.useQuery({ id: parentId ?? 0, traderId }, { enabled: parentId != null })
  const parentOpQuery = trpc.operational.get.useQuery({ id: parentId ?? 0, traderId }, { enabled: parentId != null })

  const parentDefaults = useMemo((): EventFormParentDefaults | undefined => {
    if (parentPoQuery.data) return parentDefaultsFromPurchaseOrder(parentPoQuery.data)
    if (parentOpQuery.data) return parentDefaultsFromOperational(parentOpQuery.data)
    return undefined
  }, [parentPoQuery.data, parentOpQuery.data])

  const isLoading = parentId != null && (parentPoQuery.isFetching || parentOpQuery.isFetching)

  return { parentId, parentDefaults, isLoading }
}
